import getCurrentHostName from 'src/js/utils/get-current-hostname';
import getDomain from './domain';

const getIsB2C = (rootState) => getCurrentHostName() === getDomain(rootState);

export default getIsB2C;
